import { CRUISE_DATES_FILTER, NIGHTS_FILTER, PROMOTION_STATUS_ACTIVE, PROMO_KEY } from 'components/CruiseSearchWidget/constants';
import { PromoSelection, Promotion, Selection } from 'components/FiltersProvider/types';
import { CUSTOM_FILTERS_KEY, FilterFacet } from 'lib/apiClient';

export interface UpdateFiltersFacetsWithAppliedPromotionProps {
	filtersFacets: Array<FilterFacet>;
	promotion?: Promotion;
	promoSelection?: PromoSelection;
}

export const getSelectionUpdatedByPromotion = (currentSelection: Selection, promotionData?: Promotion): Selection => {
	if (!promotionData) {
		return currentSelection;
	}

	let filtersForFaceting: Selection = { ...currentSelection, [PROMO_KEY]: [], [CUSTOM_FILTERS_KEY]: [] };

	for (const filter in promotionData.criteriaToSearchSelection) {
		if (currentSelection[filter]?.length === 0) {
			filtersForFaceting = { ...filtersForFaceting, [filter]: promotionData.criteriaToSearchSelection[filter] };
		}
	}
	return filtersForFaceting;
};

export const updateFiltersFacetsWithAppliedPromotion = ({
	filtersFacets,
	promotion,
	promoSelection,
}: UpdateFiltersFacetsWithAppliedPromotionProps): Array<FilterFacet> => {
	if (!promotion) {
		return filtersFacets;
	}

	const { criteriaToSearchSelection, valid, status, criteria = [] } = promotion;

	if (!promoSelection || status !== PROMOTION_STATUS_ACTIVE || !valid || criteria.length === 0) {
		return filtersFacets;
	}

	return filtersFacets.map(({ key, facets }) => {
		if (key === CRUISE_DATES_FILTER.key || key === NIGHTS_FILTER.key) {
			return { key, facets };
		}

		return {
			key,
			facets: facets.map(({ code, count }) => {
				const criteriaOptions = criteriaToSearchSelection[key] ?? [];
				const isIncludedOnCriteria = criteriaOptions.length === 0 || criteriaOptions.includes(code);

				return {
					code,
					count: isIncludedOnCriteria ? count : 0,
				};
			}),
		};
	});
};
